import { render } from "./skills.vue?vue&type=template&id=5c459d7c&scoped=true"
import script from "./skills.vue?vue&type=script&lang=js"
export * from "./skills.vue?vue&type=script&lang=js"

import "./skills.vue?vue&type=style&index=0&id=5c459d7c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c459d7c"]])

export default __exports__